import ArrowForwardIcon from "@mui/icons-material/ArrowForwardIos";
import { BaseButtonProps, Button } from "../Button";

export interface PaginationNextProps
  extends
    BaseButtonProps,
    Omit<React.ComponentPropsWithoutRef<"button">, "color"> {}
export const PaginationNext = (props: PaginationNextProps) => {
  return <Button icon={<ArrowForwardIcon />} {...props} />;
};
